<script setup lang="ts">
const props = defineProps<{
  type: 'current' | 'duration'
}>()

const controls = inject(diKeys.mediaControls)

const duration = computed(() => {
  const seconds = (props.type === 'current' ? controls?.currentTime?.value : controls?.duration?.value) ?? 0
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return [mins, secs].map(n => n.toString().padStart(2, '0')).join(':')
})
</script>

<template>
  <span class="tabular-nums" v-text="duration" />
</template>
